export const MENU_BUTTON_CLICKED = 'menu:button:clicked';
